class PreviousLinkController {
  constructor() {
    this.name = 'previousLink';
  }
}

export default PreviousLinkController;
